export default (st)=>{
    let date = new Date(st);
    return date.toDateString();
}